import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { QuestionTypeEnum } from '../../../../../globalTypes/base.types';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { Logger } from '../../../helper/logger';
import { JsonPipe } from '@angular/common';
const log = new Logger('PoseQuestionComponent');

@Component({
  selector: 'msh-pose-question',
  imports: [FormsModule, MatSelectModule],
  template: `
@if(questionType === "TEXT"){
  <input
    type="text"
    [placeholder]="displayLabel"
    [(ngModel)]="answer"
    name="listing.name"
    [required]="isMandatory"
    (blur)="onBlur($event)"
  />
}@else if(["SINGLE_SELECT","MULTI_SELECT"].includes(questionType) ){
  <mat-select
    [multiple]="questionType === 'MULTI_SELECT'"
    (selectionChange)="onBlur($event)"
    [placeholder]="displayLabel"
    class="w-full mb-7 mt-2 block px-3 py-2 rounded border border-navy/15"
    [(ngModel)]="answer"
    [required]="isMandatory"
    >
    @for(option of options; track option.id;){
      <mat-option [value]="option.optionValue">{{option.optionValue}}</mat-option>
    }
  </mat-select>
}
  `,
  styles: ``
})
export class PoseQuestionComponent implements OnChanges{
  @Input() questionType: QuestionTypeEnum = "TEXT";
  @Input() displayLabel: string = '';
  @Input() isMandatory: boolean = false;
  @Input() options: {id: string, optionText: string, optionValue: string, sortOrder?: number | null}[] = [];
  @Input() answer: string | string[] = '';
  @Output() onChange: EventEmitter<string | string[]> = new EventEmitter<string | string[]>

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['answer']){
      if(this.questionType === "SINGLE_SELECT" && typeof this.answer !== 'string'){
        this.answer = this.answer.join(',')
      }
    }
  }

  onBlur(ev: any){
    log.log({ev})
    this.onChange.emit(ev.value);
  }

}
